import Route from '@ember/routing/route';

export default class DashboardUrlSiteAuditAllChecksIndexRoute extends Route {}
